<div
  *ngIf="workCouncilComments.length; else noCommentsRef"
  class="overflow-scroll h-100"
  #commentListRef
>
  <base-customer-work-council-comment
    *ngFor="let comment of workCouncilComments; trackBy: trackByCommentDate"
    class="d-block mb-4 p-4 bg-lightest rounded-xll"
    [comment]="comment"
  ></base-customer-work-council-comment>
</div>

<ng-template #noCommentsRef>
  <div class="h-100">
    <base-empty-list-row
      [backgroundSecondary]="true"
      [hideBackgroundImage]="true"
      message="workCouncil.comments.emptyList"
    ></base-empty-list-row>
  </div>
</ng-template>

<form [ngClass]="{ 'was-validated': submitted }">
  <base-textarea
    [placeholder]="'workCouncil.comments.placeholder' | translate"
    [formControl]="workCouncilCommentControl"
    customClasses="no-min-height"
    [autoGrowEnabled]="true"
    errorMessage="validation.required"
    [isInvalid]="!!workCouncilCommentControl.errors"
    [errorMessage]="workCouncilCommentControl.errors | baseFieldValidation"
    [isRequired]="true"
    [rows]="1"
  ></base-textarea>
</form>
<base-button
  class="d-inline-block mt-3"
  color="dark"
  [size]="buttonSize.xs"
  [disabled]="workCouncilCommentControl.value.trim().length === 0"
  (btnClick)="sendComment($event)"
>
  {{ 'workCouncil.comments.sendBtn' | translate }}
</base-button>
